import React from 'react';
import { useIsMobile } from '@/hooks';
import DualSymbolCardMobile from './DualSymbolCardMobile';
import styles from './DualSymbolCard.module.scss';

interface DualSymbolCardProps {
  title1: string;
  detail1: string;
  title2: string;
  detail2: string;
  backgroundColor: string;
  textColor: string;
  detailColor: string;
  symbol1: string;
  symbolDetail1: string;
  symbol2: string;
  symbolDetail2: string;
  icon: string;
}

const DualSymbolCard: React.FC<DualSymbolCardProps> = ({
  title1,
  detail1,
  title2,
  detail2,
  backgroundColor,
  textColor,
  detailColor,
  symbol1,
  symbolDetail1,
  symbol2,
  symbolDetail2,
  icon,
}) => {
  const isMobile = useIsMobile();
  return isMobile ? (
    <DualSymbolCardMobile
      symbolDetail={symbolDetail1}
      detailColor={detailColor}
      textColor={textColor}
      title1={title1}
      title2={title2}
      symbol={symbol1}
      detail1={detail1}
      detail2={detail2}
      backgroundColor={backgroundColor}
      icon={icon}
    />
  ) : (
    <div className={styles.card} style={{ backgroundColor }}>
      <div className={styles.iconContainer}>
        <img src={icon} alt="card-icon" />
      </div>
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.symbolContainer}>
            <span className={styles.symbol} style={{ color: textColor }}>
              {symbol1}
            </span>
            <span className={styles.symbolDetail} style={{ color: textColor }}>
              {symbolDetail1}
            </span>
          </div>
          <span className={styles.title} style={{ color: textColor }}>
            {title1}
          </span>
          <span className={styles.detail} style={{ color: detailColor }}>
            {detail1}
          </span>
        </div>
        <div className={styles.section}>
          <div
            className={styles.divider}
            style={{ backgroundColor: textColor }}
          />
          <div className={styles.symbolContainer}>
            <span className={styles.symbol} style={{ color: textColor }}>
              {symbol2}
            </span>
            <span className={styles.symbolDetail} style={{ color: textColor }}>
              {symbolDetail2}
            </span>
          </div>
          <span className={styles.title} style={{ color: textColor }}>
            {title2}
          </span>
          <span className={styles.detail} style={{ color: detailColor }}>
            {detail2}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DualSymbolCard;
